import { setGetListHistoryAction } from '../action';
import { getListHistory } from '../api/getListHistory';

const setGetListHistory = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getListHistory(params);

            if (data.status === 'success') {
                dispatch(setGetListHistoryAction({
                    data: data.data,
                    countPage: data.countPage
                }));
            }

        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetListHistory
}